/**
 * Zweck: Beschreibt class BonuspunktprogrammStufe und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bonuspunktprogramm-stufe.ts.
 */
export class BonuspunktprogrammStufe {
  AbBonuspunktSaldo: number;
  GutschriftProzent: string;

  // GUI
  level: number;
}
